<template>
  <Drawer v-model="openMap" height="380" placement="bottom">
    <div>
      <div id="qrcode"></div>
      <div style="margin-top: 20px;text-align: center;">
        <h2>{{ item.carNo }}</h2>
        <p>截止时间：{{
          utils.time(item.endTime)
        }}</p>
      </div>
      <div id="shareButton">
        <input id="href" type="text" v-model="item.href" readonly />
        <Button @click="copy" long>复制链接分享</Button>
      </div>
    </div>
    <canvas id="canvas" style="display: none"></canvas>
  </Drawer>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      openMap: false,
      item: {
        deviceNo: "",
        carNo: "",
        href: "",
        endTime: new Date(),
      },
    };
  },
  methods: {
    open(v) {
      this.item.carNo = v.carNo;
      this.item.deviceNo = v.deviceNo;
      this.openMap = true;
    },
    makeCode(data) {
      this.item = data;
      this.openMap = true;

      var divobj = document.getElementById("qrcode");
      divobj.innerHTML = "";
      divobj.title = "";
      var that = this;
      new QRCode(document.getElementById("qrcode"), {
        text: this.item.href,
        width: 200,
        height: 200,
        colorDark: "#15c415",
        colorLight: "#fff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    copy() {
      var input = document.getElementById("href");
      href.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
        this.$Message.success("复制成功");
      }
    },
    end(t) {
      var now = Date.now();
      var to = t * 3600000;
      this.item.endTime = new Date(now + to);
    },
    jietu() {
      var ele = document.createElement("a");
      ele.setAttribute("href", this.htmlToImage()); //设置下载文件的url地址
      ele.setAttribute("download", "二维码"); //用于设置下载文件的文件名
      ele.click();
    },
    htmlToImage() {
      var canvas = document.getElementById("canvas");
      var context = canvas.getContext("2d");
      var video = document.getElementById("qrcode");
      var width = video.offsetWidth;
      var height = video.offsetHeight;
      canvas.width = width;
      canvas.height = height;
      console.log(canvas.toDataURL("image/png"));
      var img = new Image();
      img.src =
        "http://106.53.93.140:8090/lygps-download/lygps-module/user/avatar/4ADDE906DF684716B573AA24F2559E84/cdc2e91c-f33a-43b8-a69f-8746546d7eff.jpg";
      context.drawImage(img, 0, 0, width, height);
      return canvas.toDataURL("image/png");
    },
    reset() {
      var divobj = document.getElementById("qrcode");
      divobj.innerHTML = "";
      divobj.title = "";
      this.item.href = "";
    },
  },
  mounted() {
    this.end(2);
  },
};
</script>
<style lang="">
#qrcode {
  width: 200px;
  height: 200px;
  background: #ccc;
  margin: 0 auto;
  
}
#shareButton {
  background: #fff;
}
#shareButton #href {
  width: calc(100% - 0px);
  border: none;
  background: none;
  height: 0px;
}
#shareButton #href:focus {
  border: none;
  outline: none;
}
</style>


// WEBPACK FOOTER //
// src/components/locate/com/shareMakeCode.vue